
import {
    DELETE_TICKET_OUT,
    DELETE_TRANSACTION, GLOBAL_PDF_PREVIEW, GLOBAL_RESET_PDF_PREVIEW_DATA, GLOBAL_STORE_PDF_PREVIEW_READY,
    LIST_ALL_TICKET_OUT,
    LIST_ALL_TRANSACTION,
    POINT_PDF_PREVIEW, POINT_RESET_PDF_PREVIEW_DATA,
    POINT_STORE_PDF_PREVIEW_READY,
    ROLLOVER_REQUEST_TRANSACTION,
    ROLLOVER_TRANSACTION,
    SAVE_CASH_LEFT_DETAILS,
    SAVE_TICKET_OUT,
    SAVE_TRANSACTION,
    STORE_ALL_ROLLOVER_REQUEST_TRANSACTION,
    STORE_ALL_TICKET_OUT,
    STORE_ALL_TRANSACTION, STORE_REPORT_PHOTOS,
    STORE_UPDATED_TICKET_OUT,
    STORE_UPDATED_TRANSACTION,
    TRANSACTION_PDF_PREVIEW,
    TRANSACTION_RESET_PDF_PREVIEW_DATA,
    TRANSACTION_STORE_PDF_PREVIEW_READY,
} from '../../constants/ticketOut';

export const listTicketOut = (data) => ({
    type: LIST_ALL_TICKET_OUT,
    data
})

export const storeAllTicketOut = (data) => ({
    type: STORE_ALL_TICKET_OUT,
    data
})

export const storeUpdatedTicketOut = (data) => ({
    type: STORE_UPDATED_TICKET_OUT,
    data
})

export const deleteTicketOut = (data) => ({
    type: DELETE_TICKET_OUT,
    data
})

export const saveTicketOut = (data,callback) => ({
    type: SAVE_TICKET_OUT,
    data,
    callback
})

// Transactions:

export const listTransaction = (data) => ({
    type: LIST_ALL_TRANSACTION,
    data
})

export const storeAllTransaction = (data) => ({
    type: STORE_ALL_TRANSACTION,
    data
})

export const storeUpdatedTransaction = (data) => ({
    type: STORE_UPDATED_TRANSACTION,
    data
})

export const deleteTransaction = (data) => ({
    type: DELETE_TRANSACTION,
    data
})

export const saveTransaction = (data,callback) => ({
    type: SAVE_TRANSACTION,
    data,
    callback
})

export const getPDFPreview = (pdfPreview, setPdfError) => ({
    type: TRANSACTION_PDF_PREVIEW,
    pdfPreview,
    setPdfError
})

export const storePDFpreviewReady = (storePDFPreviewReady) => ({
    type: TRANSACTION_STORE_PDF_PREVIEW_READY,
    storePDFPreviewReady
})

export const resetPdfPreviewData = () => ({
    type: TRANSACTION_RESET_PDF_PREVIEW_DATA,
})

export const saveCashLeft = (data,callback) => ({
    type: SAVE_CASH_LEFT_DETAILS,
    data,
    callback
})

export const rollOverTransaction = (data,callback) => ({
    type: ROLLOVER_TRANSACTION,
    data,
    callback
})


export const rollOverRequestList = (data) => ({
    type: ROLLOVER_REQUEST_TRANSACTION,
    data
})

export const storeAllRolloverRequest = (data) => ({
    type: STORE_ALL_ROLLOVER_REQUEST_TRANSACTION,
    data
})


//point report
export const getPointPDFPreview = (pdfPreview, setPdfError) => ({
    type: POINT_PDF_PREVIEW,
    pdfPreview,
    setPdfError
})

export const storePointPDFPreviewReady = (storePointPDFPreviewReady) => ({
    type: POINT_STORE_PDF_PREVIEW_READY,
    storePointPDFPreviewReady
})

export const resetPointPdfPreviewData = () => ({
    type: POINT_RESET_PDF_PREVIEW_DATA,
})

//Global Report

export const getGlobalPDFPreview = (pdfPreview, setPdfError,intent) => ({
    type: GLOBAL_PDF_PREVIEW,
    pdfPreview,
    setPdfError,
    intent
})

export const storeGlobalPDFPreviewReady = (storePDFPreviewReady) => ({
    type: GLOBAL_STORE_PDF_PREVIEW_READY,
    storePDFPreviewReady
})

export const storeReportPhotos = (reportPhotos) => ({
    type: STORE_REPORT_PHOTOS,
    reportPhotos
})


export const resetGlobalPdfPreviewData = () => ({
    type: GLOBAL_RESET_PDF_PREVIEW_DATA,
})